module.exports = __webpack_public_path__ + "img/IS.60b99bfc.svg";